export function menu() {
  document.getElementById("hamburger").addEventListener("click", () => {
    document.querySelector(".menu-btn-cnt").classList.toggle("is-active");
    {
      once: true;
    }
  });

  const elem = document.querySelector(".menu-btn-cnt");
  const noticeH = document.querySelector(".header-notice").offsetHeight;
  const headerH = document.getElementById("site-header").offsetHeight;

  if (window.outerWidth <= 800 && document.querySelector("#wpadminbar")) {
    const wpLoggedInH = document.getElementById("wpadminbar").offsetHeight;
    elem.style.top = `${wpLoggedInH + noticeH + headerH}px`;
  } else {
    if (window.outerWidth <= 800) {
      elem.style.top = `${noticeH + headerH}px`;
    }
  }
}
